import { asyncToGenerator as _asyncToGenerator } from '../_virtual/_rollupPluginBabelHelpers.js';

function getFetchPolyfill() {
  return _getFetchPolyfill.apply(this, arguments);
}
/**
 * Create deferred fetch polyfill
 */


function _getFetchPolyfill() {
  _getFetchPolyfill = _asyncToGenerator(function* () {
    var {
      default: fetch
    } = yield import('isomorphic-fetch');
    return fetch;
  });
  return _getFetchPolyfill.apply(this, arguments);
}

function fetch() {
  return _fetch2.apply(this, arguments);
}
/**
 * Hack to get correct protocol for given request
 * @param {ClientRequest} req
 * @returns {('http:'|'https:')}
 */

function _fetch2() {
  _fetch2 = _asyncToGenerator(function* () {
    var _fetch = process.browser ? window.fetch || (yield getFetchPolyfill()) : yield getFetchPolyfill();

    return _fetch(...arguments);
  });
  return _fetch2.apply(this, arguments);
}

export { fetch };
